import type { ClassValue } from 'clsx';
import clsx from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    // should be published with the design-tokens: https://prisma.atlassian.net/browse/UXX-703
    classGroups: {
      'font-size': [
        'text-legacy-size-base',
        'text-legacy-size-xs',
        'text-headline-l',
        'text-headline-m',
        'text-title-m',
        'text-title-s',
        'text-body-l',
        'text-body-m',
        'text-body-s',
        'text-body-base',
        'text-label-l',
        'text-label-m',
        'text-label-s',
        'text-label-base',
      ],
      'font-weight': [
        'headline',
        'title',
        'body-regular',
        'body-italic',
        'body-semibold',
        'label-regular',
        'label-italic',
        'label-semibold',
        'legacy-bold',
      ],
    },
  },
});

/**
 * Combines multiple class names or conditional class names and merges Tailwind CSS classes efficiently.
 * See https://ayberkyavas.com/blogs/wtf-is-clsx-twmerge-cn-in-tailwindcss or https://www.reddit.com/r/tailwindcss/comments/1egbuvx/the_buzz_around_cn_function_and_why_do_we_use_it/
 * for more information.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(...classes));
}
